import { ListingClient, ListingStatus } from 'src/WebApiController';

export async function tryAutoBroadcastListing({
  client,
  listingId,
  listingStatus,
  effectivePrice,
  autoBroadcastEnabled,
  hasFeature,
}: {
  client: ListingClient;
  listingId: number;
  listingStatus: ListingStatus | null | undefined;
  effectivePrice: number | null | undefined;
  autoBroadcastEnabled: boolean | null | undefined;
  hasFeature: boolean;
}): Promise<boolean> {
  if (!hasFeature) return false;

  const isNotListed =
    listingStatus != null &&
    listingStatus !== ListingStatus.Listed &&
    listingStatus !== ListingStatus.ListingPending;

  console.log('[AutoBroadcast] evaluation', {
    listingId,
    listingStatus,
    effectivePrice,
    autoBroadcastEnabled,
    isNotListed,
    hasFeature,
  });

  if (
    autoBroadcastEnabled === true &&
    effectivePrice != null &&
    effectivePrice !== 0 &&
    isNotListed
  ) {
    console.log(
      '[AutoBroadcast] conditions met — calling createMarketplaceListings'
    );
    const result = await client.createMarketplaceListings(listingId, []);
    console.log('[AutoBroadcast] result', result);
    return result;
  }
  console.log('[AutoBroadcast] skipped — conditions not met');
  return false;
}
